import { useEffect, useState } from 'react'

interface Data {
  session: Storage
  local: Storage
}

export const useStorage = (onLoad?: (storage: Data) => void): Data => {
  const [storage, setStorage] = useState<Data>({
    local: undefined,
    session: undefined,
  })

  useEffect(() => {
    const next: Data = {
      local: localStorage,
      session: sessionStorage,
    }
    setStorage(next)
    onLoad && onLoad(next)
  }, [])

  return storage
}
